var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomOut = function SvgZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.75 10.75a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0m-6.727-.788h3.037v1.5h-3.037v.001h-1.5v-.001H7.25v-1.5h4.773m8.227.788a8.96 8.96 0 0 1-2.02 5.68l3.92 3.92-1.061 1.061-3.901-3.9a9 9 0 1 1 3.063-6.76"
  })));
};
export default SvgZoomOut;